/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_Deneme_SuresiInputs */

const tr_faq_q_deneme_suresi = /** @type {(inputs: Faq_Q_Deneme_SuresiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deneme süresi var mı?`)
};

const en_faq_q_deneme_suresi = /** @type {(inputs: Faq_Q_Deneme_SuresiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is there a free trial?`)
};

const de_faq_q_deneme_suresi = /** @type {(inputs: Faq_Q_Deneme_SuresiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gibt es eine kostenlose Testphase?`)
};

const ru_faq_q_deneme_suresi = /** @type {(inputs: Faq_Q_Deneme_SuresiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Есть ли бесплатный пробный период?`)
};

/**
* | output |
* | --- |
* | "Is there a free trial?" |
*
* @param {Faq_Q_Deneme_SuresiInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_deneme_suresi = /** @type {((inputs?: Faq_Q_Deneme_SuresiInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_Deneme_SuresiInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_deneme_suresi(inputs)
	if (locale === "de") return de_faq_q_deneme_suresi(inputs)
	if (locale === "ru") return ru_faq_q_deneme_suresi(inputs)
	return tr_faq_q_deneme_suresi(inputs)
});